var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinDealerDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c8.774 0 15.912 7.066 16 15.84C32 26.8 18 39 17.3 39.52a2 2 0 0 1-2.6 0c-.157-.136-1.232-1.066-2.736-2.562l-.384-.386C7.257 32.203 0 23.702 0 15.84.088 7.066 7.226 0 16 0zm8.012 30H8.052c4.48 5.076 6.792 7.657 6.937 7.743.588.343 1.453.343 2.04 0 .171-.086 2.499-2.667 6.983-7.743zM16 10a5 5 0 1 0 0 10 5 5 0 0 0 0-10z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDealerDetail);
export default __webpack_public_path__ + "static/media/pin-dealer-detail.f4ed20213428a93eb6bfaaac0fdc3938.svg";
export { ForwardRef as ReactComponent };